export default function Trust({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      className={className}
    >
      <path
        d="M12.957 13.9033C15.0704 13.9033 16.7837 12.1901 16.7837 10.0767C16.7837 7.96326 15.0704 6.25 12.957 6.25C10.8436 6.25 9.13037 7.96326 9.13037 10.0767C9.13037 12.1901 10.8436 13.9033 12.957 13.9033Z"
        stroke="#336DE1"
        strokeWidth="1.65926"
        strokeMiterlimit="10"
      />
      <path
        d="M14.2166 19.7815H6.90993C6.86993 19.5149 6.84326 19.2415 6.84326 18.9682C6.84326 16.1749 9.10993 13.9082 11.9033 13.9082H12.9033"
        stroke="#336DE1"
        strokeWidth="1.65926"
        strokeMiterlimit="10"
      />
      <path
        d="M14.5562 17.1944L16.7695 19.341L21.4495 14.2344"
        stroke="#336DE1"
        strokeWidth="1.65926"
        strokeMiterlimit="10"
      />
      <path
        d="M13.5482 26.3747C20.5401 26.3747 26.2082 20.7066 26.2082 13.7147C26.2082 6.72276 20.5401 1.05469 13.5482 1.05469C6.55626 1.05469 0.888184 6.72276 0.888184 13.7147C0.888184 20.7066 6.55626 26.3747 13.5482 26.3747Z"
        stroke="#336DE1"
        strokeWidth="1.65926"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
